import { useMutation } from "react-query";
import { createSubscription } from "../api/plans/createSubscription";

export const useMutationCreateSubscription = () =>
  useMutation(["create-subscription"], createSubscription);
